import React, { createContext, useState, useContext, useEffect, useRef } from "react";

// Create the context
const GlobalContext = createContext();

// Create a provider component
export const GlobalProvider = ({ children }) => {
  const [showModal, setShowModal] = useState(false);
  const [formSource, setFormSource] = useState("NAA");
  const showModalRef = useRef(showModal);

  // Function to update the state
  // const updateModalState = (newValue) => {
  //   setShowModal(newValue);
  // };
  useEffect(() => {
    showModalRef.current = showModal;
  }, [showModal]);

  useEffect(() => {
    const timer = window.setTimeout(() => {
      if (!showModalRef.current) {
        setFormSource("Timer Popup");
        setShowModal(true);
      }
    }, 7000);

    return () => window.clearTimeout(timer);
  }, []);

  const handleShowModal = (source = "NAA") => {
    setFormSource(source);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setFormSource("NAA");
  };

  return (
    <GlobalContext.Provider
      value={{ showModal, handleShowModal, handleCloseModal, formSource }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

// Custom hook for using the Global Context
export const useGlobalContext = () => {
  return useContext(GlobalContext);
};
